import React, {Component} from "react"
import {Route, withRouter, RouteComponentProps} from "react-router-dom"

import {NestedRoute} from "@irati/utils/history/routing"
import NotFound from "../NotFound"
import Maintenance from "../Maintenance"
import ContactPreferencesExternal from "../ContactPreferencesExternal"
import ContactPreferencesSuccessExternal from "../ContactPreferencesExternal/Success"

import OneTimePassword from "../../containers/OneTimePassword"
import SelfSignUp from "../../containers/SignUp"
import SelfSignUpRedirect from "../../containers/SignUp/SignUpRedirect"
import {redirectToAppStoreUrl} from "../shared/index"
import Welcome from "./welcome"

interface Props extends RouteComponentProps {
  path: string
}

class platform extends Component<Props> {
  render() {
    const {path} = this.props
    redirectToAppStoreUrl(this.props.location.search.replace("?", ""))

    return (
      <Route path={path}>
        <>
          <Route path="/welcome" component={Welcome} />
          <NestedRoute noauth match={path} path="maintenance" component={Maintenance} title="Perkbox under maintenance" />
          <NestedRoute
            noauth
            exact
            match={path}
            path="marketing/prefs/:userId/:signature"
            title="Contact Preferences"
            useGrid={false}
            component={ContactPreferencesExternal}
          />
          <NestedRoute
            noauth
            match={path}
            path="marketing/prefs/success"
            title="Contact Preferences"
            useGrid={false}
            component={ContactPreferencesSuccessExternal}
          />
          <NestedRoute noauth match={path} path="activate" title="One Time Password" useGrid={false} component={OneTimePassword} />
          <NestedRoute noauth match={path} path="signup" title="Self Sign Up" useGrid={false} component={SelfSignUp} />
          <NestedRoute
            noauth
            match={path}
            path="signupRedirect"
            title="Self Sign Up Redirect"
            useGrid={false}
            component={SelfSignUpRedirect}
          />
          <Route path="NotFound" component={NotFound} />
        </>
      </Route>
    )
  }
}

export default withRouter(platform)
